import { CSSProperties, PropsWithChildren } from 'react';
import { When } from 'react-if';
import { buildAssetsUrl } from '@zep/utils/common/assetsUrl';
import { cn } from '@zep/utils/tailwind';
import { Profile } from '../Profile';
import S from './Avatar.module.scss';

/**
 *
 * @param name skin | clothes | face | hair
 * @param id 1 ~ 999
 * @returns http|s://baseUrl/path/sprites/{name}/-${id}.png
 */
function getSpriteImageUrl(name: string, id: number) {
  return buildAssetsUrl(`/static/assets/sprites/${name}/-${id}.png`);
}
export const Avatar = (props: PropsWithChildren<AvatarProps>) => {
  const {
    skin = 2,
    clothes = 8,
    face = 1,
    hair = 73,
    accessoryIds,
    posture = 'front',
    behavior = 'stand',
    className
  } = props;
  const playerInfo = {
    skin,
    clothes,
    face,
    hair,
    ...(normalizeAccessoryId(accessoryIds?.mask) > 0 && {
      mask: normalizeAccessoryId(accessoryIds?.mask)
    }),
    ...(normalizeAccessoryId(accessoryIds?.glasses) > 0 && {
      glasses: normalizeAccessoryId(accessoryIds?.glasses)
    })
  };
  return <div className={cn(S.character, {
    [S.left]: posture === 'left',
    [S.right]: posture === 'right',
    [S.back]: posture === 'back',
    [S.front]: posture === 'front'
  }, {
    [S.jump]: behavior === 'jump',
    [S.sit]: behavior === 'sit',
    [S.stand]: behavior === 'stand',
    [S.walk]: behavior === 'walk',
    [S.dance]: behavior === 'dance'
  }, className)} data-sentry-component="Avatar" data-sentry-source-file="Avatar.tsx">
      {Object.entries(playerInfo).map(([name, id], index) => <span key={index} className={S.object} style={{
      '--image-url': `url(${getSpriteImageUrl(name, id)})`
    } as CSSProperties} aria-hidden="true"></span>)}
      <When condition={playerInfo.skin <= 0} data-sentry-element="When" data-sentry-source-file="Avatar.tsx">
        <div className={S.empty_profile}>
          <Profile empty data-sentry-element="Profile" data-sentry-source-file="Avatar.tsx" />
        </div>
      </When>
    </div>;
};
export type AvatarProps = {
  skin?: number;
  clothes?: number;
  face?: number;
  hair?: number;
  accessoryIds?: Record<string, number | null | undefined>;
  posture?: 'left' | 'right' | 'back' | 'front';
  behavior?: 'stand' | 'sit' | 'jump' | 'walk' | 'dance';
  className?: string;
};
function normalizeAccessoryId(value: number | null | undefined) {
  if (typeof value !== 'number' || !Number.isFinite(value)) return 0;
  return Math.abs(value);
}